import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleSummaryReportByGroup } from 'domain/usecases';

interface ISummaryReportByGroup {
  summaryReportByGroup: HandleSummaryReportByGroup.Result;
}

interface IPayloadSummaryReportByGroup
  extends PayloadAction<HandleSummaryReportByGroup.Result> {}

const initialState: ISummaryReportByGroup = {
  summaryReportByGroup: null,
};

export const SummaryReportByGroupSlice = createSlice({
  name: 'summary-report-by-group',
  initialState,
  reducers: {
    loadSummaryReportByGroup: (state, action: IPayloadSummaryReportByGroup) => {
      state.summaryReportByGroup = action.payload;
    },
    clearSummaryReportByGroup: (state) => {
      state.summaryReportByGroup = null;
    },
  },
});

export const { loadSummaryReportByGroup, clearSummaryReportByGroup } =
  SummaryReportByGroupSlice.actions;

export default SummaryReportByGroupSlice.reducer;
